import { useContext } from 'react';

import { A11yToolbarTabIndexContext } from '../context/A11yToolbarTabIndexContext.js';
import { ToolbarInteractionModes } from '../types/toolbar-interaction-modes.js';
import { A11yToolbarTabIndex } from '../types/toolbar.js';
import {
  getTabIndexKey,
  getTabIndexValue,
} from '../utils/a11yToolbarControls.js';

/**
 * Get tabIndex value from context. depending on the param type
 *
 * @internal
 * @param type - toolbar buttons type
 */
export const useA11yToolbarTabIndex = (type: ToolbarInteractionModes) => {
  const tabIndexContext = useContext<A11yToolbarTabIndex[]>(
    A11yToolbarTabIndexContext,
  );

  const toolbarTabIndex = tabIndexContext.find(
    (tab) => getTabIndexKey(tab) === type,
  );

  return toolbarTabIndex ? getTabIndexValue(toolbarTabIndex) : -1;
};
